(() => {
  const scrollToSos = () => {
    if (location.hash !== '#sos-ricambi') return;
    const target = document.getElementById('sos-ricambi');
    if (target) target.scrollIntoView({ block: 'start', behavior: 'instant' });
  };
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href]');
    if (!link) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || url.hash !== '#sos-ricambi' || url.pathname !== location.pathname) return;
    if (!document.getElementById('sos-ricambi')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    history.replaceState(history.state, '', url.pathname + url.search + url.hash);
    scrollToSos();
  }, true);
  window.addEventListener('hashchange', scrollToSos);
  if (document.readyState === 'complete') scrollToSos();
  else window.addEventListener('load', scrollToSos, { once: true });
  window.addEventListener('pageshow', scrollToSos);
})();
